module.exports = __webpack_public_path__ + "img/cmdb1.74628903.png";